<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "工单派发" : "工单派发" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        max-width='700'
        :fullscreen='$isMobile'
      >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-card outlined class="pa-2 mb-5">
              <v-row>
                <v-col cols="12">
                  <v-card elevation="0">
                    <v-card-title class="pt-0">
                      <span class="text--secondary">{{item.data.serialNumber}}</span>
                      <v-spacer></v-spacer>
                      {{item.data.year}}年
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          客户名称：<span class="text--secondary">{{item.data.customer.name}}</span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12">
                          产品名称：<span class="text--secondary">
                            {{item.data.product.name}}
                            <span v-if="item.data.bookkeepingDic && item.data.bookkeepingDic.length >0">
                              (<span v-for="(item, idx) in item.data.bookkeepingDic" dark color="primary" x-small class="mr-1" :key="idx">
                                +{{item.name}}
                              </span>)
                            </span>
                          </span>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" md="6">
                          项目归属：<span class="text--secondary">{{item.data.product.ownerUser.name}}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
            <v-row>
              <v-col cols="12" md="12">
                <v-select
                    :items="orderUrgentLevelItems"
                    label="紧急程度"
                    v-model="form.urgentLevelId"
                    hide-details='auto'
                    outlined
                    item-text='name'
                    item-value="id"
                    :rules="required"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="$constants.ProductType.AuditReport.indexOf(item.data.product.id) !== -1">
              <v-col cols="12" md="6">
                <v-select
                  multiple
                  :items="yearItems"
                  label="审计年度"
                  v-model="form.years"
                  hide-details='auto'
                  outlined
                  item-text='label'
                  :rules="array"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  :items="[{ text: '自主收款', value: 1 },{ text: '事务所代收', value: 2 }]"
                  label="收款类型"
                  v-model="form.collectionType"
                  hide-details='auto'
                  outlined
                  :rules="required"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="$constants.ProductType.ZhuZuoQuan.indexOf(item.data.product.id) !== -1">
              <v-col cols="12">
                <v-select
                  multiple
                  :items="patentPurposesItems"
                  label="知识产权用途"
                  v-model="form.purposeList"
                  hide-details='auto'
                  outlined
                  item-text='name'
                  item-value="id"
                  return-object
                  :rules="array"
                ></v-select>
              </v-col>
            </v-row>
            <div v-if="$constants.ProductType.FaMingZhuanLi.indexOf(item.data.product.id) !== -1">
              <v-row>
                <v-col cols="12" md='6'>
                  <v-select
                    :rules="number"
                    hide-details="auto"
                    outlined
                    :items="[ { text: '有', value: 1}, {text: '无', value: 0}]"
                    label="是否有交底材料"
                    v-model="form.patent.haveData"
                  ></v-select>
                </v-col>
                <v-col cols="12" md='6'>
                  <v-select
                    :rules="number"
                    hide-details="auto"
                    outlined
                    :items="[ { text: '可以', value: 1}, {text: '不可以', value: 2}]"
                    label="是否可费减"
                    v-model="form.patent.reduction"
                  ></v-select>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12">
                <v-textarea outlined  rows='3' v-model="form.remark" label="备注"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { getByPids } from '@/api/system/dictionary.js'
  import { save } from '@/api/order/index.js'
  import { selectData2 } from '@/utils/tool.js'
  import {
    isEmptyArray,
    isEmpty
  } from '@/utils/stringUtil.js'

  export default {
    name: 'AuditOut',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]*$/.test(value) || '此项为必填项',
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        yearItems: selectData2(),
        orderUserItems: [],
        orderUrgentLevelItems: [],
        patentPurposesItems: [],
        form: {
          id: '',
          personId: '',
          orderNumber: '',
          urgentLevelId: '',
          startTimeStr: '',
          startTime: '',
          productId: '',
          customerId: '',
          contractId: '',
          purposeList: [],
          purposes: '',
          doYear: '',
          years: [],
          remark: '',
          patent: {},
          collectionType: ''
        },
        defForm: {
          id: '',
          personId: '',
          orderNumber: '',
          urgentLevelId: '',
          startTimeStr: '',
          startTime: '',
          productId: '',
          customerId: '',
          contractId: '',
          purposeList: [],
          purposes: '',
          doYear: '',
          years: [],
          remark: '',
          patent: {},
          collectionType: ''
        }
      }
    },
    methods: {
      save () {
        this.buildForm()
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      orderNumber () {
        this.form.orderNumber = this.item.data.serialNumber
      },
      buildForm () {
        if (!isEmptyArray(this.form.purposeList)) {
            this.form.purposes = JSON.stringify(this.form.purposeList.filter(item => item).map(({ name, id }) => ({ name: name, id: id })))
          }
        if (!isEmpty(this.form.startTimeStr)) {
          this.form.startTime = new Date(this.form.startTimeStr).getTime() / 1000
        }
        this.form.years = this.form.years.toString()
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form.productId = this.item.data.product.id
          this.form.customerId = this.item.data.customer.id
          this.form.contractId = this.item.data.id
          this.form.doYear = this.item.data.year
          this.form.personId = this.item.data.product.ownerUserId
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
        this.orderNumber()
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.orderUsersPid,
              this.$constants.orderUrgentLevelPid,
              this.$constants.patentPurposesPid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.orderUsersPid === result.id) {
                this_.orderUserItems = result.data
             } else if (this_.$constants.orderUrgentLevelPid === result.id) {
                this_.orderUrgentLevelItems = result.data
             } else if (this_.$constants.patentPurposesPid === result.id) {
                this_.patentPurposesItems = result.data
             }
           })
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    },
    created() {
      this.getTypes()
    }
  }
</script>

<style lang="sass" scoped>
</style>
